import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Security = () => {
  return (
    <EmptyPage
      title="Security Settings"
      description="Manage security policies, authentication settings, access controls, and monitor security events for your platform."
      icon="🛡️"
    />
  );
};

export default Security;
